import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { WrittenDirective } from '../../_types/awb';

export const fetchWrittenDirectives = async (
  accreditationBodyId: string,
  versionId: string,
  standardId: string,
  jurisdictionId: string
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/standards/${standardId}/jurisdiction/${jurisdictionId}/written-directives`;

  const data = await fetcher({
    method: 'get',
    url,
  });
  return data;
};

export default function useWrittenDirectives(
  accreditationBodyId: string,
  versionId: string,
  standardId: string,
  jurisdictionId: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<WrittenDirective[], Error>(
    ['written_directives', accreditationBodyId, versionId, standardId, jurisdictionId],
    () => fetchWrittenDirectives(accreditationBodyId, versionId, standardId, jurisdictionId),
    {
      staleTime: 900000, // 15 minutes in milliseconds
      ...options,
    }
  );
}
